import React, {useLayoutEffect} from 'react';
import {matchPath} from 'react-router';
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {routes} from '../../../../../core/models/static/routes/app-routes';
import useAccessLevels from '../../../../hooks/use-access-levels';
import ContactUsMessagesView from './contact-us-messages';

/**
 * Support section router — access-gated pages under /support.
 */
const SupportViews = () => {
    const location = useLocation();
    const history = useHistory();
    const {packages} = useAccessLevels();
    const canSeeContactUsMessages = packages.support.contactUsMessages;

    /**
     * Redirects the support base path to the first available child route.
     */
    useLayoutEffect(() => {
        if (!matchPath(location.pathname, {path: routes.support.base, exact: true})) {
            return;
        }
        if (canSeeContactUsMessages) {
            history.replace(routes.support.contactUsMessages);
        }
    }, [canSeeContactUsMessages, history, location.pathname]);

    return (
        <Switch>
            <Route path={routes.support.base} exact/>
            {
                canSeeContactUsMessages &&
                <Route path={routes.support.contactUsMessages} exact>
                    <ContactUsMessagesView/>
                </Route>
            }
            <Redirect to={routes.support.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default SupportViews;
